import { Badge } from '@vnetwork/ui/primitives';
import type { AlarmSeverity } from '@/api/healthcheck';
import { severityTone } from '../shared';

interface Props {
  severity: AlarmSeverity;
  size?: 'sm' | 'md';
}

export function SeverityBadge({ severity, size = 'sm' }: Props) {
  return (
    <Badge
      tone={severityTone(severity)}
      appearance="subtle"
      size={size}
      style={{ textTransform: 'capitalize' }}
    >
      {severity}
    </Badge>
  );
}
